"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PopularDirectionOptions = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _styles = require("../styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var PopularDirectionOptions = function PopularDirectionOptions(_ref) {
  var country = _ref.country,
      label = _ref.label;
  if (!country) return null;
  var labelCountry = country.name_ru,
      visa_type_ru = country.visa_type_ru;
  return /*#__PURE__*/_react["default"].createElement(Row, null, /*#__PURE__*/_react["default"].createElement(PopularCountryDescription, null, /*#__PURE__*/_react["default"].createElement(_styles.TitleBlock, null, /*#__PURE__*/_react["default"].createElement(_styles.ContainerText, null, /*#__PURE__*/_react["default"].createElement(_styles.LabelText, null, label, ", ", labelCountry), /*#__PURE__*/_react["default"].createElement(_styles.SubtitleBlock, null, visa_type_ru)))));
};

exports.PopularDirectionOptions = PopularDirectionOptions;

var PopularCountryDescription = _styledComponents["default"].div.withConfig({
  displayName: "PopularDirectionOptions__PopularCountryDescription",
  componentId: "sc-1jnp7jy-0"
})(["position:absolute;top:0;left:0;right:0;bottom:0;padding:4px 0 0 8px;z-index:1;"]);

var Row = _styledComponents["default"].div.withConfig({
  displayName: "PopularDirectionOptions__Row",
  componentId: "sc-1jnp7jy-1"
})(["height:48px;"]);